module.exports = __webpack_public_path__ + "static/media/09.Falicitation to Bhaskar kamath.2b1b459e.jpg";